var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "book-component-list-item",
      class: _vm.isActive && "book-component-list-item--active",
      attrs: { tag: "div", to: _vm.file.path }
    },
    [
      _c("font-awesome-icon", {
        staticClass: "book-component-list-item__icon",
        attrs: { icon: _vm.faFile }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "book-component-list-item__file-name" }, [
        _vm._v("\n    " + _vm._s(_vm.name) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }